import { styled } from '@mui/material'

// Global UI
import { TypographyH2, TypographyP } from '@/ui'

export const SectionTitle = styled(TypographyH2)(({ theme }) => ({
  color: '#333333',
  fontSize: theme.typography.pxToRem(30),
  lineHeight: '1.2em',
  fontWeight: 600,
  margin: 0,
  padding: 0,
}))

export const SectionSubTitle = styled(TypographyP)(({ theme }) => ({
  color: '#777777',
  fontSize: theme.typography.pxToRem(20),
  lineHeight: theme.typography.pxToRem(30),
  fontWeight: 400,
}))

export const GalleryHeadingTitle = styled(TypographyH2)(({ theme }) => ({
  fontWeight: 300,
  fontSize: theme.typography.pxToRem(44),
  lineHeight: 1.08,
  color: '#372d2b',
  textTransform: 'capitalize',

  '& .firstHeadline': {
    fontSize: theme.typography.pxToRem(44),
    fontWeight: 300,
    lineHeight: '1.04em',
    textAlign: 'center',
  },
  '& .secondHeadline': {
    fontSize: theme.typography.pxToRem(44),
    fontWeight: 'bold',
    lineHeight: '1.04em',
    textAlign: 'center',
  },
}))
